export default [
  { id: 'MALE', name: 'Samiec' },
  { id: 'FEMALE', name: 'Samica' },
]
